export const chartData = {
    type: '',
    data: {
        labels: [],
        datasets: []
    },
    options: {
        responsive: true,
        lineTension: 1,
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                        padding: 25
                    }
                }
            ]
        }
    }
}

export default chartData



// WEBPACK FOOTER //
// ./src/plugins/chart.js